import { Navbar, Nav, Container } from "react-bootstrap";
import ScrollspyNav from "react-scrollspy-nav";

function NavigationBar() {
    return <div>
        <ScrollspyNav offset={-20} scrollTargetIds={["about", "event", "fam", "sponsor"]} activeNavClass="active" scrollDuration="100">
            <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark" fixed="top" id="navbar">
                <Container>
                    <Navbar.Brand href="#home"><h2>MTSA</h2></Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav"/>
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto">
                            <Nav.Link href="#about"><h3>About</h3></Nav.Link>
                            <Nav.Link href="#event"><h3>Events</h3></Nav.Link>
                            <Nav.Link href="#fam"><h3>Fam</h3></Nav.Link>
                            <Nav.Link href="#sponsor"><h3>Sponsors</h3></Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </ScrollspyNav>
    </div>;  
}

export default NavigationBar; 